module.exports = __webpack_public_path__ + "img/leaderboard_icon.fb0613af.svg";